let UserRole = /*#__PURE__*/function (UserRole) {
  UserRole[UserRole["Owner"] = 0] = "Owner";
  UserRole[UserRole["Manager"] = 1] = "Manager";
  UserRole[UserRole["Employee"] = 2] = "Employee";
  return UserRole;
}({});

export { UserRole };
//# sourceMappingURL=user-role.js.map
